// Order requested: Error, Success, Quantilia Analysis, GP Production, MOI Validation, Validated
export const tsfStatusOPCVM = [
  { value: "error", label: "Erreur" },
  { value: "success", label: "Succès" },
  { value: "quantilia_analysis", label: "Analyse Quantilia" },
  { value: "gp_production", label: "Production GP" },
  { value: "moi_validation", label: "À valider MOI" },
  { value: "validated", label: "Validé" },
];

// For A7 FIA, no "success" status
export const tsfStatusFIA = [
  { value: "error", label: "Erreur" },
  { value: "quantilia_analysis", label: "Analyse Quantilia" },
  { value: "gp_production", label: "Production GP" },
  { value: "moi_validation", label: "À valider MOI" },
  { value: "validated", label: "Validé" },
];

// For backward compatibility, keep tsfStatus with all statuses
export const tsfStatus = [
  ...tsfStatusOPCVM,
  // No need to duplicate values already in tsfStatusOPCVM
];
